import axios from 'axios/index'

const baseUrl = process.env.BACKEND_URL

function validateLogin(login, password) {
  return axios({
    method: 'post',
    url: `${baseUrl}/login`,
    headers: {
      'x-login': login,
      'x-password': password
    },
  })
}

export default {
  validateLogin,
}
